import { useSelector } from "react-redux";
import CompanyHomeHeader from "./components/CompanyHomeHeader";
import CompanyHomeChart from "./components/CompanyHomeChart";
import CompanyHomeTalent from "./components/CompanyHomeTalent";
import CompanyHomeNewsAndJob from "./components/CompanyHomeNewsAndJob";
import CompanyHomeSummary from "./components/CompanyHomeSummary";
import TalentDetailPanel from "../talent/components/TalentDetailPanel";
import { MESSAGE_SEND_FROM } from "../../constants/index";

const CompanyDashboard = () => {
  const isOpenDetailTalentPanel = useSelector((state: any) => state.companyHome.isOpenDetailTalentPanel);
  return (
    <>
      <div className="flex-1">
        <CompanyHomeHeader />
        <CompanyHomeChart />
        <CompanyHomeSummary />
        <CompanyHomeTalent />
        <CompanyHomeNewsAndJob />
        {isOpenDetailTalentPanel && <div className="fixed right-2 top-2 bottom-2 z-[999]"><TalentDetailPanel open={isOpenDetailTalentPanel} onClose={() => {}} onScreen={MESSAGE_SEND_FROM.HOME} /></div>}
      </div>
    </>
  );
};

export default CompanyDashboard;